import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'

/**
 * Base
 */
// Debug
const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// // Axes helper
// const axesHelper = new THREE.AxesHelper()
// scene.add(axesHelper)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('/textures/matcaps/8.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace
/**
 * Fonts
 * /
 */

const donutsArray = []
const fontLoader = new FontLoader()
fontLoader.load(
    '/fonts/BN_Boxer_Regular_reveresed.json', (font) =>
{
    const textGeometry = new TextGeometry(
        'ZIV, CREATIVE DEVELOPER',
        {
            font: font,
            size: 0.5,
            depth: 0.2,
            curveSegments: 32,
            bevelEnabled: true,
            bevelThickness: 0.02,
            bevelSize: 0.01,
            bevelOffset: 0,
            bevelSegments: 10
        })

    textGeometry.computeBoundingBox()
    textGeometry.center()


    const material = new THREE.MeshMatcapMaterial({
        matcap: matcapTexture
    })
    const textBoundingBox = new THREE.Box3().setFromObject(new THREE.Mesh(textGeometry));
    const text = new THREE.Mesh(textGeometry, material);
    scene.add(text);
    
    const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
    
    
    // Create donuts with safe positions
    const PADDING = 1; // Distance to keep from text
    textBoundingBox.expandByScalar(PADDING);
    const SPAWN_RANGE = 10;
  
  for (let i = 0; i < 100; i++) {
    const donut = new THREE.Mesh(donutGeometry, material);
    
    // Using do...while to guarantee at least one iteration
    do {
      donut.position.set(
        (Math.random() - 0.5) * SPAWN_RANGE,
        (Math.random() - 0.5) * SPAWN_RANGE,
        (Math.random() - 0.5) * SPAWN_RANGE
      );
    } while (textBoundingBox.containsPoint(donut.position));

    // Set random rotation and scale
        donut.rotation.set(
        Math.random() * Math.PI,
        Math.random() * Math.PI,
        Math.random() * Math.PI
        );
        
        const scale = Math.random();
        donut.scale.set(scale, scale, scale);
        
        
        const randomX = Math.random() * 0.8 - 0.1;
        donutsArray.push([donut, randomX]);
        scene.add(donut);
    }
})

/**
 * Object
 */
// const cube = new THREE.Mesh(
//     new THREE.BoxGeometry(1, 1, 1),
//     new THREE.MeshBasicMaterial()
// )

// scene.add(cube)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    precision: 'highp'
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
console.log(donutsArray)
const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()


    donutsArray.forEach((donut, index) => {
        const [donutMesh, randomX] = donut
        donutMesh.rotation.x = elapsedTime * randomX
        donutMesh.rotation.y = elapsedTime * randomX
    })

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()